import styled from 'styled-components';

export const AISummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  flex-shrink: 0;
  background: #fff;
  padding: 16px;
  margin-bottom: 4px;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 5%);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const AISummaryTitleLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AISummaryTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
`;

export const ResponseContent = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
  line-height: 1.6;

  pre {
    margin: 0;
    font-size: 12px;
    font-family: Monaco, Menlo, monospace;
    white-space: pre-wrap;
    word-break: break-word;
  }

  /* Markdown styling */
  h3 {
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 20px;
    line-height: 1.4;
    color: #262626;
    font-weight: 600;
  }

  h4 {
    margin-top: 24px;
    margin-bottom: 12px;
    font-size: 16px;
    line-height: 1.4;
    color: #262626;
    font-weight: 600;
  }

  h4:first-child {
    margin-top: 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    display: table;
    font-size: 14px;
  }

  th,
  td {
    padding: 10px 14px;
    text-align: left;
    border: 1px solid #d9d9d9;
    vertical-align: top;
  }

  th {
    background: #fafafa;
    font-weight: 600;
    color: #262626;
  }

  tr:hover {
    background: #f5f5f5;
  }

  ul,
  ol {
    margin: 12px 0;
    padding-left: 28px;
    line-height: 1.8;
  }

  li {
    margin: 6px 0;
  }

  p {
    margin: 12px 0;
    line-height: 1.7;
    white-space: normal;
    color: #262626;
  }

  hr {
    margin: 24px 0;
    border: none;
    border-top: 2px solid #e8e8e8;
  }

  code {
    background: #f5f5f5;
    padding: 3px 8px;
    border-radius: 3px;
    font-family: Monaco, Menlo, monospace;
    font-size: 13px;
    color: #d63384;
  }

  strong {
    font-weight: 600;
    color: #262626;
  }

  em {
    font-style: italic;
  }

  blockquote {
    margin: 16px 0;
    padding-left: 16px;
    border-left: 4px solid #e8e8e8;
    color: #595959;
  }
`;

export const LoadingContainer = styled.div`
  padding: 16px;
  text-align: center;
  color: #8c8c8c;

  div {
    margin-top: 8px;
  }
`;

export const ErrorContent = styled.div`
  padding: 16px;
  color: #ff4d4f;

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 12px;
    font-family: Monaco, Menlo, monospace;
  }
`;
